import {useMainContext} from "../../contexts/main";
import RTableLayout from "./RTableLayout";
import {HistoryResponsiveRow, Row, TradeTypeBadge} from "../../styles/table";
import {SOCKET_URL} from "../../constants/urls";
import {CFlex, DText, Flex} from "../../styles/MarketStyles";
import Text from "../../utils/Text";
import {formatDate, formatNumber} from "../../utils/common";
import {BuyIcon, CancelOrderBtn, SellIcon, TextWithMargin} from "../../styles/OrdersStyle";
import {getTradeTypeColor} from "../../utils/theme";


const RHistory = ({ data }) => {

    const { main: { lang } } = useMainContext()
    const { data: trades } = data

    return (
        <RTableLayout
            data={data}
        >
            {trades?.data?.map((item, idx) => (
                <Row cs={'100%'} index={idx}>
                    <Flex fw justify={'space-between'} style={{ direction: 'ltr' }}>
                        <Flex>
                            <img
                                style={{ marginRight: '-10px', zIndex: 10 }}
                                src={SOCKET_URL + `assets/icon/${item.order?.coin}.png`}
                                alt={' '}
                                width={20}
                                height={20}
                            />
                            {item.order?.pair === 'irt' ?
                                <img
                                    src={require('../../assets/images/tooman.png')}
                                    alt={' '}
                                    width={20}
                                    height={20}
                                />
                                :
                                <img
                                    src={SOCKET_URL + `assets/icon/${item.order?.pair}.png`}
                                    alt={' '}
                                    width={20}
                                    height={20}
                                />
                            }
                            <DText primary fontSize={'m'} style={{ margin: '0 5px' }}>
                                {`${item.order?.coin?.toUpperCase()}/${item.order?.pair?.toUpperCase()}`}
                            </DText>
                            <TextWithMargin style={{ margin: '0 5px', fontSize: '0.9rem' }}>
                                {`${item.order.type === 'buy' ? 'Buy' : 'Sell'}/${item.order.submit}`}
                            </TextWithMargin>
                        </Flex>
                    </Flex>
                    <HistoryResponsiveRow>
                        <DText main fontSize={'s'}>
                            <Text tid={'amount'} />
                        </DText>
                        <DText primary fontSize={'s'}>
                            {formatNumber(item.amount)}
                        </DText>
                    </HistoryResponsiveRow>
                    <HistoryResponsiveRow>
                        <DText main fontSize={'s'}>
                            <Text tid={'price'} />
                        </DText>
                        <DText primary fontSize={'s'}>
                            {formatNumber(item.price)}
                        </DText>
                    </HistoryResponsiveRow>
                    <HistoryResponsiveRow>
                        <DText main fontSize={'s'}>
                            <Text tid={'priceUnit'} />
                        </DText>
                        <DText primary fontSize={'s'}>
                            {formatNumber(item.priceUnit)}
                        </DText>
                    </HistoryResponsiveRow>
                    <HistoryResponsiveRow>
                        <DText main fontSize={'s'}>
                            <Text tid={'date'} />
                        </DText>
                        <DText primary fontSize={'s'}>
                            {`${formatDate(item.createdAt, "time", lang === "en" ? "en-US" : "fa-IR")}
                                    - ${formatDate(item.createdAt, "date", lang === "en" ? "en-US" : "fa-IR")}`}
                        </DText>
                    </HistoryResponsiveRow>
                </Row>
            ))}
        </RTableLayout>
    )
}

export default RHistory;
